import { combineReducers } from 'redux';

import mainSlice from 'src/store/mainSlice/mainSlice.reducer';
import clientSlice from 'src/store/clientSlice/clientSlice.reducer';
import addressSlice from 'src/store/addressSlice/addressSlice.reducer';

const combinedReducer = combineReducers({
  userState: mainSlice,
  clientState: clientSlice,
  addressState: addressSlice,
});

export const RESET_STORE_ACTION_TYPE = 'RESET_WHOLE_STORE';

const rootReducer = (
  state: ReturnType<typeof combinedReducer> | undefined,
  action: { type: string; payload: unknown },
) => {
  if (action.type === RESET_STORE_ACTION_TYPE) {
    return combinedReducer(undefined, action);
  }

  return combinedReducer(state, action);
};

export default rootReducer;
